import MegaMenuTrigger from '@components/Layout/Header/components/NavigationCollections/MegaMenuTrigger';
import React, { lazy, Suspense, useRef, useState } from 'react';
import { useOnClickOutside } from '@monofront/business/hooks';
import { createPortal } from 'react-dom';
import { useLayoutRefs } from '@context/layoutRefs';
import HighlightedLinks from './HighlightedLinks';
import { SimpleNavigation } from './SimpleNavigation';

const MegaMenu = lazy(
  () =>
    import(
      '@components/Layout/Header/components/NavigationCollections/MegaMenu'
    ),
);

export const NavigationCollections = () => {
  const { mainBottomRef } = useLayoutRefs();
  const [megaMenuTriggerBottom, setMegaMenuTriggerBottom] = useState<
    number | undefined
  >(undefined);
  const [isMegaMenuOpen, setIsMegaMenuOpen] = useState(false);
  const refMegaMenuContainer = useRef<HTMLDivElement>(null);
  const refMegaMenuTrigger = useRef<HTMLUListElement>(null);

  useOnClickOutside(refMegaMenuContainer, () => setIsMegaMenuOpen(false));

  return (
    <>
      {/* Trigger */}
      <nav role="navigation" style={{ scrollbarWidth: 'none' }}>
        <ul
          ref={refMegaMenuTrigger}
          className="tw-flex tw-flex-row tw-gap-x-6 tw-leading-5"
        >
          <MegaMenuTrigger
            isMegaMenuOpen={isMegaMenuOpen}
            setIsMegaMenuOpen={() => {
              if (!isMegaMenuOpen && refMegaMenuTrigger.current) {
                const { bottom } =
                  refMegaMenuTrigger.current.getBoundingClientRect();

                setMegaMenuTriggerBottom(bottom);
              }
              setIsMegaMenuOpen((prev) => !prev);
            }}
          />
          <HighlightedLinks />
        </ul>
      </nav>

      {/* Mega Menu */}
      <SimpleNavigation />
      {isMegaMenuOpen && (
        <nav
          className={`tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-z-dropdown tw-m-auto tw-h-full tw-w-full desktop:tw-absolute desktop:tw-bottom-auto desktop:tw-left-auto desktop:tw-right-auto desktop:tw-top-auto desktop:tw-z-auto`}
          id="mega-menu-nav"
          tabIndex={-1}
          aria-label="mega menu collections"
        >
          <div
            ref={refMegaMenuContainer}
            className="tw-h-full desktop:tw-inline-block desktop:tw-h-auto"
          >
            <Suspense fallback={null}>
              <MegaMenu
                isMegaMenuOpen={isMegaMenuOpen}
                setIsMegaMenuOpen={setIsMegaMenuOpen}
                menuTop={megaMenuTriggerBottom}
              />
            </Suspense>
          </div>
        </nav>
      )}
      {isMegaMenuOpen &&
        mainBottomRef.current &&
        createPortal(
          <div className="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-top-0 tw-hidden tw-bg-overlay desktop:tw-block" />,
          mainBottomRef.current,
        )}
    </>
  );
};
